<template>
  <div class="home-page">
    <div class="content-blocks-row">
      <!-- 使用 v-for 渲染多个内容块 -->
      <div class="content-block" v-for="(block, index) in blocks" :key="index">
        <!-- 图标 -->
        <img class="icon" :src="block.icon" alt="icon" />
        <!-- 标题，超出显示省略号 -->
        <div class="title" :title="block.title">{{ block.title }}</div>
        <!-- 简介，最多显示两行 -->
       <div class="description" >{{ block.description }}</div>
        <div v-if="block.description2" class="description">{{ block.description2 }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpecialMajor',
  data() {
    return {
      blocks: [
        {
          icon: require('@/assets/image/index/zhzs.png'),
          title: '智慧招商',
          description: '精准匹配全球资源',
          description2: '打造智能化招商引资服务平台',
        },
        {
          icon: require('@/assets/image/index/sqch.png'),
          title: '陕企出海',
          description: '助力本土企业开拓国际市场',
          description2: '提供全方位跨境服务支持',
        },
        {
          icon: require('@/assets/image/index/qyglgw.png'),
          title: '管理顾问',
          description: '赋能企业成长，提供战略咨询',
          description2: '管理优化等专业化顾问服务',
        },
        {
          icon: require('@/assets/image/index/sqxgj.png'),
          title: '企服管家',
          description: '一站式企业服务管家',
          description2: '解决企业发展中的各类实际问题',
        },
        {
          icon: require('@/assets/image/index/cyhz.png'),
          title: '产业合作',
          description: '搭建产业链对接平台',
          description2: '促进跨区域、跨行业协同发展',
        },
        {
          icon: require('@/assets/image/index/cxcy.png'),
          title: '创新产业',
          description: '聚焦新兴产业培育',
          description2: '推动服务贸易创新业态发展',
        },
        {
          icon: require('@/assets/image/index/sqzj.png'),
          title: '陕企之家',
          description: '凝聚陕企力量，搭建合作平台',
          description2: '共促服务贸易创新发展',
        },
        {
          icon: require('@/assets/image/index/kjfn.png'),
          title: '科技赋能',
          description: '注入科技活力，驱动产业变革',
          description2: '为服务贸易增添新引擎',
        }
      ]
    };
  }
};
</script>

<style scoped>
.home-page {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 2vw 10vw;
  /* border: 1px solid yellow; */
}

.content-blocks-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap; /* 让元素在小屏幕时换行 */
 /* border: 1px solid blue; */
}

.content-block {
  width: 25%; /* 每个块占据 1/4 宽度 */
  padding: 1vw;
  margin-bottom: 1vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* border: 1px solid red; */
}

.icon {
  width: 4vw;
  height: 4vw;
  margin-bottom: 0.5vw;
 /* border: 1px solid red; */
}

.title {
   text-align: center;
  font-size: 1vw;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /* 不允许换行 */
  margin-bottom: 0.5vw;
}

.description {
  width: 100%;
  font-size: 0.7vw;
  color: #999;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 限制显示两行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-wrap: break-word;
  white-space: normal; /* 允许换行 */
  text-align: center;
}

@media (max-width: 768px) {
  .content-block {
   width: 50%; /* 每个块占据 1/4 宽度 */
  }
  .icon {
    width: 18vw;
    height: 18vw;
    margin-bottom: 1vw;
   /* border: 1px solid red; */
  }
  .title {
    font-size: 3vw;
    margin-bottom: 1vw;
  }
  .description {
    width: 100%;
    font-size: 2vw;
  }
  /* .content-blocks-row {
    flex-direction: column;
  } */
}
</style>
